<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        dense
        item-key="lot"
        show-expand
        class="reduced order-table"
        :headers="filteredHeaders"
        :items="products"
        :expanded.sync="expandedRows"
        :footer-props="footerProps"
        @click:row="expandRow"
        @current-items="setCurrentRows"
      >
        <template v-slot:[`body.prepend`]="{ isMobile }">
          <tr>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-combobox
                dense
                hide-details
                clearable
                multiple
                color="secondary"
                v-model.trim="filterPriceGroup"
                label="Гр.пр"
                item-text="text"
                item-value="value"
                :items="priceGroups"
              ></v-combobox>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                dense
                hide-details
                clearable
                height="25"
                color="secondary"
                v-model="filterName"
                label="Наименование"
                ref="filterName"
                @click="clearFilterName"
                @click:clear="clearFilterName"
              ></v-text-field>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                dense
                hide-details
                clearable
                height="25"
                color="secondary"
                v-model="filterManufacturer"
                label="Производитель"
              ></v-text-field>
            </td>
            <!-- <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
                    <v-text-field
                      dense
                      hide-details
                      clearable
                      color="secondary"
                      height="25"
                      v-model="filterCountry"
                      label="Страна"
                    ></v-text-field>
            </td>-->
            <!-- <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
                    <v-layout align-center>
                      <v-flex>
                        <v-menu
                          offset-y
                          transition="scale-transition"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              dense
                              hide-details
                              readonly
                              clearable
                              height="25"
                              color="secondary"
                              v-on="on"
                              label="Начало"
                              v-model="filterStartExpiration"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="secondary"
                            v-model="filterStartExpiration"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex>
                        <v-icon class="mx-1">{{ icons.arrowLeftRight }}</v-icon>
                      </v-flex>
                      <v-flex>
                        <v-menu
                          offset-y
                          transition="scale-transition"
                          :close-on-content-click="false"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              dense
                              hide-details
                              readonly
                              clearable
                              height="25"
                              color="secondary"
                              v-on="on"
                              label="Окончание"
                              v-model="filterEndExpiration"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="secondary"
                            v-model="filterEndExpiration"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                    </v-layout>
            </td>-->
          </tr>
        </template>

        <template v-slot:[`item.manufacturer`]="{ item }">
          <span class="caption">{{ item.manufacturer }}</span>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <span class="body-1 font-weight-medium" :class="getNameColor(item)">
            {{ item.name }}
            <span v-if="item.isEnrollPrice">*</span>
          </span>
          <v-avatar size="30" color="secondary" v-if="item.isPrescription">
            <v-icon dark>{{ icons.prescription }}</v-icon>
          </v-avatar>
          <v-avatar size="30" color="light-blue" v-if="item.isColdZone">
            <v-icon dark>{{ icons.temperatureCelsius }}</v-icon>
          </v-avatar>
        </template>

        <template v-slot:[`item.country`]="{ item }">
          <span class="caption">{{ item.country }}</span>
        </template>

        <template v-slot:[`item.expiration`]="{ item }">
          <span v-if="isLowExpiration(item.expiration)">
            <v-chip dark color="red">
              {{ item.expiration | expiration }}
            </v-chip>
          </span>
          <span v-else>{{ item.expiration | expiration }}</span>
        </template>

        <template v-slot:[`item.price`]="{ item }">
          <v-layout justify-end>{{ item.price }}</v-layout>
        </template>

        <template v-slot:[`item.pack`]="{ item }">
          <v-layout justify-end>{{ item.pack }}</v-layout>
        </template>

        <template v-slot:[`item.quantity`]="{ item }">
          <v-layout justify-end>{{ item.quantity }}</v-layout>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <DeliveryPointsQuantity
              ref="DeliveryPointsQuantity"
              :points="points"
              :product="item"
              :states="productsStates"
            />
          </td>
        </template>

        <template v-slot:no-results>
          <v-alert color="error" :icon="icons.alert" :value="true"
            >Не найден результат для "{{ filterName }}"</v-alert
          >
        </template>

        <template v-slot:no-data>
          <v-alert :value="true" type="warning">Записи не найдены</v-alert>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { Icon } from "@/helpers";

import DeliveryPointsQuantity from "@/components/Orders/DeliveryPointsQuantity";

export default {
  props: {
    products: Array,
    points: Array,
    productsStates: Array,
  },
  components: {
    DeliveryPointsQuantity,
  },
  computed: {
    headers: function () {
      return [
        {
          text: "Гр.прайса",
          value: "priceGroup",
          width: "3%",
          align: "center",
          filter: (value) => {
            if (
              !this.filterPriceGroup ||
              this.filterPriceGroup == null ||
              this.filterPriceGroup.length == 0
            )
              return true;

            return this.filterPriceGroup.some((item) => {
              return item.value == value;
            }); //value == this.filterPriceGroup;
          },
        },
        {
          text: "Наименование",
          value: "name",
          filter: (value) => {
            if (!this.filterName) return true;

            let count = 0;
            let worlds = this.filterName.split(' ');
            worlds.forEach(function(item, index, array) {
              let regex = new RegExp(
                  "(^|\\(|\\s+)" +
                    item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
                  "i"
                );
              if (value.search(regex) != -1)
                count++;
            });

            return count == worlds.length;

            // return (
            //   value.search(
            //     new RegExp(
            //       "(^|\\(|\\s+)" +
            //         this.filterName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            //       "i"
            //     )
            //   ) > -1
            // );
          },
        },
        {
          text: "Производитель",
          value: "manufacturer",
          filter: (value) => {
            if (!this.filterManufacturer) return true;

            let count = 0;
            let worlds = this.filterManufacturer.split(' ');
            worlds.forEach(function(item, index, array) {
              let regex = new RegExp(
                  "(^|\\(|\\s+)" +
                    item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
                  "i"
                );
              if (value.search(regex) != -1)
                count++;
            });

            return count == worlds.length;

            // return (
            //   value.search(
            //     new RegExp(
            //       "(^|\\(|\\s+)" +
            //         this.filterManufacturer.replace(
            //           /[.*+?^${}()|[\]\\]/g,
            //           "\\$&"
            //         ),
            //       "i"
            //     )
            //   ) > -1
            // );
          },
        },
        // {
        //   text: "Страна",
        //   value: "country",
        //   filter: value => {
        //     if (!this.filterCountry) return true;

        //     return value.search(new RegExp(this.filterCountry, "i")) > -1;
        //   }
        // },
        {
          text: "Срок годности",
          value: "expiration",
          align: "center",
          filter: (value) => {
            if (!this.filterStartExpiration && !this.filterEndExpiration)
              return true;

            if (this.filterStartExpiration && this.filterEndExpiration)
              return this.$dayjs(value).isBetween(
                this.filterStartExpiration,
                this.filterEndExpiration
              );

            if (this.filterStartExpiration) {
              return this.$dayjs(value).isSameOrAfter(
                this.filterStartExpiration,
                "day"
              );
            }

            if (this.filterEndExpiration)
              return this.$dayjs(value).isSameOrBefore(
                this.filterEndExpiration,
                "day"
              );
          },
        },
        {
          text: "Цена",
          value: "price",
          align: "right",
        },
        {
          text: "Упаковка",
          value: "pack",
          align: "right",
        },
        {
          text: "Остаток",
          value: "quantity",
          align: "right",
        },
        {
          text: "",
          value: "data-table-expand",
        },
      ];
    },
    priceGroups: function () {
      let result = Array.from(
        [...new Set(this.products.map((x) => x.priceGroup))]
          .filter(function (value) {
            return Number.isInteger(value);
          })
          .sort(),
        (x) => new Object({ text: x, value: x })
      );

      result.push({ text: "б/г", value: null });

      return result;
    },
    filteredHeaders: function () {
      if (this.products.every((p) => p.quantity === 0))
        return this.headers.filter((x) => x.value !== "quantity");
      else return this.headers;
    },
    footerProps: function () {
      return this.filterName && this.filterName.length > 2
        ? { itemsPerPageOptions: [-1] }
        : {
            itemsPerPageOptions: [100, 300, 500, 700, 1000],
          };
    },
  },
  methods: {
    getNameColor: function (item) {
      if (item.isExpectedArrival) return "accent--text";

      if (item.isPromo) return "light-blue--text text--accent-3";
    },
    isLowExpiration: function (expiration) {
      if (
        this.$dayjs(expiration).isSameOrBefore(
          this.$dayjs().add(1, "year"),
          "month"
        )
      )
        return true;
    },
    expandRow: function (value) {
      let contains = this.expandedRows.includes(value);
      if (contains) {
        let index = this.expandedRows.indexOf(value);
        this.expandedRows.splice(index, 1);
      } else this.expandedRows.push(value);
    },
    setCurrentRows: function (value) {
      this.currentRows = value;
      this.currentRowIndex = -1;
    },
    clearFilterName: function () {
      this.filterName = "";
    },
    keydownEventListener: function (e) {
      if (e && e != null) {
        if (e.code == "F7") {
          this.clearFilterName();
          if (this.$refs && this.$refs.filterName) {
            this.$vuetify.goTo(".vue-sticky-placeholder");
            this.$refs.filterName.focus();
          }
        }

        if (e.target.nodeName.toLowerCase() == "input") {
          if (e.code == "Enter" || e.code == "NumpadEnter") {
            switch (e.target.type.toLowerCase()) {
              case "number":
                if (
                  this.$refs &&
                  this.$refs.DeliveryPointsQuantity &&
                  this.$refs.DeliveryPointsQuantity.$refs &&
                  this.countPoints <
                    this.$refs.DeliveryPointsQuantity.$refs.quantity.length - 1
                ) {
                  this.countPoints++;
                  this.$refs.DeliveryPointsQuantity.$refs.quantity[
                    this.countPoints
                  ].$refs.input.focus();
                } else {
                  this.countPoints = 0;
                  // this.clearFilterName();
                  // this.$refs.filterName.focus();
                  this.expandedRows.splice(0, this.expandedRows.length);
                }
                break;
              case "text":
                if (this.$refs && this.$refs.filterName)
                  this.$refs.filterName.blur();
                break;
            }
          }
        }

        if (e.target.nodeName.toLowerCase() == "body") {
          if (e.code == "Enter" || e.code == "NumpadEnter") {
            if (
              this.$refs &&
              this.$refs.DeliveryPointsQuantity &&
              this.$refs.DeliveryPointsQuantity.$refs
            )
              this.$refs.DeliveryPointsQuantity.$refs.quantity[0].$refs.input.focus();
          }

          if (
            e.code == "ArrowUp" &&
            this.currentRows &&
            this.currentRowIndex > -1
          ) {
            this.currentRowIndex--;
            this.expandedRows.splice(0, this.expandedRows.length);
            this.expandRow(this.currentRows[this.currentRowIndex]);
          }

          if (
            e.code == "ArrowDown" &&
            this.currentRows &&
            this.currentRowIndex < this.currentRows.length
          ) {
            this.currentRowIndex++;
            this.expandedRows.splice(0, this.expandedRows.length);
            this.expandRow(this.currentRows[this.currentRowIndex]);
          }

          if (e.code == "Backspace") {
            this.filterName = this.filterName.substring(
              0,
              this.filterName.length - 1
            );
          }

          if (
            e.code.startsWith("Key") ||
            e.code == "Semicolon" ||
            e.code == "Quote" ||
            e.code == "Backquote" ||
            e.code == "BracketLeft" ||
            e.code == "BracketRight" ||
            e.code == "Comma" ||
            e.code == "Period"
          ) {
            this.filterName += e.key;
          }
        }
      }
    },
  },
  data: () => ({
    expandedRows: [],
    currentRowIndex: -1,
    currentRows: [],
    filterName: "",
    filterManufacturer: "",
    filterPriceGroup: "",

    icons: {
      arrowLeftRight: Icon.arrowLeftRight,
      alert: Icon.alert,
      magnify: Icon.magnify,
      temperatureCelsius: Icon.temperatureCelsius,
      prescription: Icon.prescription,
    },
    countPoints: 0,
  }),
  mounted: function () {
    window.addEventListener("keydown", this.keydownEventListener);
  },
  beforeDestroy: function () {
    window.removeEventListener("keydown", this.keydownEventListener);
  },
};
</script>

